/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_TitleInputs */

const vi_vehicle_camera_title = /** @type {(inputs: Vehicle_Camera_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera trên xe`)
};

/**

* @param {Vehicle_Camera_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_title = /** @type {((inputs?: Vehicle_Camera_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_title(inputs)
});